// @flow

import emojiSupport from 'detect-emoji-support';

export type Platform = 'web' | 'account';

export const canShowFlagEmoji = () => {
  return emojiSupport() && !window.navigator.platform.toLowerCase().includes('win');
};
